// DebugControls.jsx - UI component for debug controls
import React from 'react';
import debugLogger from './DebugLogger';

const DebugControls = () => {
  if (process.env.NODE_ENV !== 'development') {
    return null;
  }

  const handleDownloadLogs = () => {
    const timestamp = new Date().toISOString().replace(/[:.]/g, '-');
    debugLogger.downloadLogs(`validation-debug-${timestamp}.txt`);
  };

  const handleExportToConsole = () => {
    debugLogger.exportToConsole();
  };

  const handleClearLogs = () => {
    debugLogger.clear();
    alert('Debug logs cleared!');
  };

  return (
    <div className="fixed bottom-4 right-4 bg-purple-600 text-white p-4 rounded-lg shadow-lg z-50">
      <div className="text-sm font-bold mb-2">🐛 Debug Controls</div>
      <div className="flex flex-col space-y-2">
        <button
          onClick={handleDownloadLogs}
          className="px-3 py-1 bg-green-500 hover:bg-green-600 rounded text-xs"
        >
          📄 Download Logs
        </button>
        <button
          onClick={handleExportToConsole}
          className="px-3 py-1 bg-blue-500 hover:bg-blue-600 rounded text-xs"
        >
          📋 Export to Console
        </button>
        <button
          onClick={handleClearLogs}
          className="px-3 py-1 bg-red-500 hover:bg-red-600 rounded text-xs"
        >
          🗑️ Clear Logs
        </button>
      </div>
    </div>
  );
};

export default DebugControls;
